import React from 'react';

import {ChatMessage} from '../types';

import './ChatMessages.css';

interface Props {
  messages: ChatMessage[];
  chatEndRef: React.RefObject<HTMLDivElement>;
  agentName: string;
}

export const ChatMessages = ({messages, chatEndRef, agentName}: Props) => {
  const agentInitial = agentName.trim().charAt(0).toUpperCase() || 'A';

  return (
    <div className='chat-messages'>
      {messages.map((msg, index) => (
        <div key={index} className={`chat-message chat-message--${msg.role}`}>
          <div className='chat-message__row'>
            {msg.role === 'bot' && (
              <div className='avatar ai' aria-hidden>
                {agentInitial}
              </div>
            )}
            <div className={`bubble ${msg.role === 'bot' ? 'ai' : 'user'}`}>
              {msg.type === 'thinking' ? (
                <div className='chat-message__thinking'>
                  <span />
                  <span />
                  <span />
                </div>
              ) : msg.type === 'instruction' ? (
                <div className='insight-card orange'>
                  <span className='insight-card__text'>{msg.content}</span>
                </div>
              ) : (
                <p className='chat-message__text'>{msg.content}</p>
              )}
            </div>
            {msg.role === 'user' && (
              <div className='avatar user-av' aria-hidden>
                Sie
              </div>
            )}
          </div>
        </div>
      ))}
      <div ref={chatEndRef} />
    </div>
  );
};
